module.exports = __webpack_public_path__ + "img/madame_figaro.bacd6d1.png";